import shoppingCart from './shoppingCart';

import axios from 'axios';
const config = require('../config/config');
const qs = require('qs');

/* APIs ENDPOINTS */
const SESSION_STORAGE_SESSION = 'session';
const SERVER_URL = config.backend.apiUrl;
const LOGIN_URL = SERVER_URL + '/auth/login';
const CHANGE_PASSWORD_URL = SERVER_URL + '/auth/change-password';
const RESET_URL = SERVER_URL + '/auth/reset';
const GENERATE_PASSWORD_URL = SERVER_URL + '/auth/generate-password';
const USERS_URL = SERVER_URL + '/user';
const USER_ROLES_URL = SERVER_URL + '/userRole';
const FILE_URL = SERVER_URL + '/file';
const FILE_INDEX_URL = SERVER_URL + '/file/{id}';
const FILE_URL_URL = SERVER_URL + '/file/url/{id}';
const CARDS_URL = SERVER_URL + '/card';
const STATS_URL = SERVER_URL + '/stats/';
const SETTING_URL = SERVER_URL + '/setting/';
const STORES_URL = SERVER_URL + '/store';
const CRAWLER_URL = SERVER_URL + '/crawler/';
const WISHLIST_URL = SERVER_URL + '/wishlist';
const COLLECTION_URL = SERVER_URL + '/collection';
const DECKBUILDER_URL = SERVER_URL + '/deckbuilder';
const CHATBOT_URL = SERVER_URL + '/chatbot';

function getBackendUrl() {
  return SERVER_URL;
}

// Auth APIs

async function login(payload) {
  const loginResponse = await axios.post(LOGIN_URL, payload);
  const token = loginResponse.data;
  localStorage.setItem(SESSION_STORAGE_SESSION, JSON.stringify({ token }));
  shoppingCart.updateStores();
  shoppingCart.updateUSDPrice();
  const userResponse = await getCurrentUser();
  let userData = userResponse.data;
  userData.token = token;
  localStorage.setItem(SESSION_STORAGE_SESSION, JSON.stringify(userData));
  return userData;
}

function resetPassword(payload) {
  return axios
    .post(RESET_URL, {
      email: payload.email,
    })
    .then(function (response) {
      return response;
    });
}

function changePassword(payload) {
  return axios
    .post(
      CHANGE_PASSWORD_URL,
      {
        username: payload.username,
        password: payload.password,
        newPassword: payload.newPassword,
      },
      buildHeaders(),
    )
    .then(function (response) {
      return response;
    });
}

function generatePassword(payload) {
  return axios
    .post(GENERATE_PASSWORD_URL, payload, buildHeaders())
    .then(function (response) {
      return response;
    });
}

function logout() {
  localStorage.clear(SESSION_STORAGE_SESSION);
}

function isAuthenticated() {
  return localStorage.getItem(SESSION_STORAGE_SESSION) !== null;
}

function isAdmin() {
  return (
    localStorage.getItem(SESSION_STORAGE_SESSION) !== null &&
    JSON.parse(localStorage.getItem(SESSION_STORAGE_SESSION)).role === 'ADMIN'
  );
}

function getUsername() {
  return (
    localStorage.getItem(SESSION_STORAGE_SESSION) !== null &&
    JSON.parse(localStorage.getItem(SESSION_STORAGE_SESSION)).username
  );
}

function getPriceProvider() {
  return (
    (localStorage.getItem(SESSION_STORAGE_SESSION) !== null &&
      JSON.parse(localStorage.getItem(SESSION_STORAGE_SESSION))
        .priceProvider) ||
    'cardkingdom'
  );
}

function buildHeaders() {
  if (localStorage.getItem(SESSION_STORAGE_SESSION)) {
    return {
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(localStorage.getItem(SESSION_STORAGE_SESSION)).token,
      },
    };
  } else {
    return null;
  }
}

// User APIs

function getUsers(parameters = []) {
  return axios.get(
    `${USERS_URL}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getUsersCount(parameters = []) {
  return axios.get(
    `${USERS_URL + '/count'}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getUser(id) {
  return axios.get(USERS_URL + '/' + id, buildHeaders());
}

function postUser(body) {
  return axios.post(USERS_URL + '/', body, buildHeaders());
}

function patchUser(id, body) {
  return axios.patch(USERS_URL + '/' + id, body, buildHeaders());
}

function deleteUser(id) {
  return axios.delete(USERS_URL + '/' + id, buildHeaders());
}

function getCurrentUser() {
  return axios.get(USERS_URL + '/me', buildHeaders());
}

function getUserRoles(parameters = []) {
  return axios.get(
    `${USER_ROLES_URL}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function updateMoxfieldURL(url) {
  return axios.patch(
    USERS_URL + '/moxfieldWishlist',
    { moxfieldWishlist: url },
    buildHeaders(),
  );
}

// File APIs

function getFiles(parameters = []) {
  return axios.get(
    `${FILE_URL}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getFilesCount() {
  return axios.get(FILE_URL + '/count', buildHeaders());
}

function getFile(id) {
  return axios.get(FILE_INDEX_URL.replace('{id}', id), buildHeaders());
}

function getFileURL(id) {
  return axios.get(FILE_URL_URL.replace('{id}', id), buildHeaders());
}

function postFile(file) {
  const data = new FormData();
  data.append('file', document.file);
  return axios.post(FILE_URL, data, buildHeaders());
}

function patchFile(id, payload) {
  return axios.patch(
    FILE_INDEX_URL.replace('{id}', id),
    payload,
    buildHeaders(),
  );
}

function deleteFile(id) {
  return axios.delete(FILE_INDEX_URL.replace('{id}', id), buildHeaders());
}

// Cards APIs

function getCards(parameters = []) {
  return axios.get(
    `${CARDS_URL}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getCardsBulk(parameters = []) {
  return axios.get(
    `${CARDS_URL + '/bulk'}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getCardsCount(parameters = []) {
  return axios.get(
    `${CARDS_URL + '/count'}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getCard(id) {
  return axios.get(CARDS_URL + '/' + id, buildHeaders());
}

async function getCardByName(name) {
  return axios.get(
    `${CARDS_URL}?${qs.stringify(
      { where: { name: name }, limit: 1 },
      { skipNulls: true },
    )}`,
    buildHeaders(),
  );
}

// Stores APIs

function getStores() {
  return axios.get(STORES_URL, buildHeaders());
}

// Crawler APIs

function crawl(store) {
  return axios.get(CRAWLER_URL + store, buildHeaders());
}

function deleteOldPrices() {
  return axios.get(CRAWLER_URL + 'deleteOld', buildHeaders());
}

/**
 * Starts one bulk import: all | cards | rulings | tags | rules | combos.
 *
 * Unlike the store crawlers this responds immediately, so the caller can report whether
 * the job started or was already running (409).
 */
function runImport(target) {
  return axios.get(CRAWLER_URL + 'import/' + target, buildHeaders());
}

function updateExchangeRates() {
  return axios.get(CRAWLER_URL + 'exchangeRates', buildHeaders());
}

// Wishlist APIs

function getWishlist(parameters = []) {
  return axios.get(
    `${WISHLIST_URL}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getWishlistCardIds() {
  return axios.get(WISHLIST_URL + '/ids', buildHeaders());
}

function addCardToWishlist(id) {
  return axios.post(WISHLIST_URL + '/add/' + id, {}, buildHeaders());
}

function removeCardFromWishlist(id) {
  return axios.post(WISHLIST_URL + '/remove/' + id, {}, buildHeaders());
}

function updateWishlist(cards = []) {
  return axios.post(WISHLIST_URL + '/update', { cards }, buildHeaders());
}

// Collection APIs

function getCollection(parameters = []) {
  return axios.get(
    `${COLLECTION_URL}?${qs.stringify(parameters, { skipNulls: true })}`,
    buildHeaders(),
  );
}

function getCollectionQuantities() {
  return axios.get(COLLECTION_URL + '/quantities', buildHeaders());
}

function addCardToCollection(id, quantity = 1) {
  return axios.post(
    COLLECTION_URL + '/add/' + id,
    { quantity },
    buildHeaders(),
  );
}

function setCollectionQuantity(id, quantity) {
  return axios.patch(COLLECTION_URL + '/' + id, { quantity }, buildHeaders());
}

function removeCardFromCollection(id) {
  return axios.post(COLLECTION_URL + '/remove/' + id, {}, buildHeaders());
}

function importCollection(file, mode) {
  const data = new FormData();
  data.append('file', file);
  data.append('mode', mode);
  // buildHeaders only sets Authorization, which is what we want here: axios
  // fills in the multipart boundary itself.
  return axios.post(COLLECTION_URL + '/import', data, buildHeaders());
}

function updateMoxfieldWishlist() {
  return axios.post(WISHLIST_URL + '/moxfield', {}, buildHeaders());
}

function getUSDPrice() {
  return axios.get('https://api.bluelytics.com.ar/v2/latest');
}

// Deck Builder APIs

function searchDeckBuilderCards(filters) {
  return axios.post(DECKBUILDER_URL + '/search', filters, buildHeaders());
}

function importMoxfieldDeck(url) {
  return axios.post(
    DECKBUILDER_URL + '/moxfield-deck',
    { url },
    buildHeaders(),
  );
}

function getCardKingdomPrices(names) {
  return axios.post(
    DECKBUILDER_URL + '/cardkingdom-prices',
    { names },
    buildHeaders(),
  );
}

function getFunctionalTags() {
  return axios.get(DECKBUILDER_URL + '/functional-tags', buildHeaders());
}

function getCommanderRecommendations(name) {
  return axios.get(
    `${DECKBUILDER_URL}/commander-recommendations?${qs.stringify({ name })}`,
    buildHeaders(),
  );
}

// POST rather than GET: Recommander recommends against the deck you already have,
// so the whole list goes with the request.
function getRecommanderRecommendations(name, format, deck) {
  return axios.post(
    `${DECKBUILDER_URL}/recommander-recommendations`,
    { name, format, deck },
    buildHeaders(),
  );
}

function getCommanderCombos(name) {
  return axios.get(
    `${DECKBUILDER_URL}/commander-combos?${qs.stringify({ name })}`,
    buildHeaders(),
  );
}

function getCommanderSpellbookCombos(name) {
  return axios.get(
    `${DECKBUILDER_URL}/commander-spellbook-combos?${qs.stringify({ name })}`,
    buildHeaders(),
  );
}

// Chatbot APIs

function sendChatMessage(payload) {
  return axios.post(CHATBOT_URL + '/message', payload, buildHeaders());
}

// Stats APIs

function getStats() {
  return axios.get(STATS_URL, buildHeaders());
}

// Runtime-editable configuration. Admin-only on the server, in both directions.
function getSettings() {
  return axios.get(SETTING_URL, buildHeaders());
}

function updateSettings(settings) {
  return axios.put(SETTING_URL, settings, buildHeaders());
}

const apiHelpers = {
  getBackendUrl,
  logout,
  login,
  resetPassword,
  changePassword,
  generatePassword,
  isAuthenticated,
  isAdmin,
  getUsername,
  getPriceProvider,
  getUsers,
  getUsersCount,
  getUser,
  postUser,
  patchUser,
  deleteUser,
  getCurrentUser,
  getUserRoles,
  updateMoxfieldURL,
  getFiles,
  getFilesCount,
  getFile,
  getFileURL,
  postFile,
  patchFile,
  deleteFile,
  getCards,
  getCardsBulk,
  getCardsCount,
  getCard,
  getCardByName,
  crawl,
  deleteOldPrices,
  runImport,
  updateExchangeRates,
  getStores,
  getWishlist,
  getWishlistCardIds,
  addCardToWishlist,
  removeCardFromWishlist,
  updateWishlist,
  updateMoxfieldWishlist,
  getCollection,
  getCollectionQuantities,
  addCardToCollection,
  setCollectionQuantity,
  removeCardFromCollection,
  importCollection,
  getUSDPrice,
  searchDeckBuilderCards,
  importMoxfieldDeck,
  getCardKingdomPrices,
  getFunctionalTags,
  getCommanderRecommendations,
  getRecommanderRecommendations,
  getCommanderCombos,
  getCommanderSpellbookCombos,
  sendChatMessage,
  getStats,
  getSettings,
  updateSettings,
};

export default apiHelpers;
